import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { Replay } from '@mui/icons-material';

/**
 * Floating "resend e-invoice" button, shown on the e-invoice tab of the e-services screen.
 * Same placement rules as FloatingSaveButton; sits above it when both are visible.
 */
export default function FloatingResendButton(props) {
  return (
    <Box onClick={()=>{if(!props.disabled) props?.onClick();}} style={{position: 'fixed', right: 14, bottom: props.bottom ?? 24, zIndex: 10000, opacity: props.disabled ? 0.4 : 1, pointerEvents: props.disabled ? 'none' : 'auto'}} sx={{ '& > :not(style)': { m: 1 } }}>
      <Tooltip title={props.title || "Resend e-invoice"} placement="left">
        <Fab size="medium" color={"primary"} aria-label="resend e-invoice" disabled={props.disabled}>
          <Replay />
        </Fab>
      </Tooltip>
    </Box>
  );
}
